/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Change_Detection_Medium_ButtonInputs */



/**
* | output |
* | --- |
* | "Medium" |
*
* @param {Scene_Change_Detection_Medium_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_change_detection_medium_button = /** @type {((inputs?: Scene_Change_Detection_Medium_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Change_Detection_Medium_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Moyen")
	if (locale === "de") return /** @type {LocalizedString} */ ("Medium")
	if (locale === "it") return /** @type {LocalizedString} */ ("Medio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Середина")
	if (locale === "es") return /** @type {LocalizedString} */ ("Medio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("中等的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("中くらい")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मध्यम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Médio")
	return /** @type {LocalizedString} */ ("Medium")
});